// src/components/TableCategoriaProducto.jsx
import React, { useState, useEffect, useMemo } from "react";
import { Table } from "react-bootstrap";

import {
  getCategoriasProductos,
  deleteCategoriaProducto,
} from "../helpers/rutaCategoriasProductos";

import ModalCategoriaProducto from "./ModalCategoriaProducto";
import "../css/tableclientes.css";

const clean = (v) => String(v ?? "").trim();

const normalizarCategorias = (r) => {
  if (Array.isArray(r?.categorias)) return r.categorias;
  if (Array.isArray(r)) return r;
  if (Array.isArray(r?.data)) return r.data;
  return [];
};

const mostrarSiNo = (valor) => (valor ? "SÍ" : "NO");

const TableCategoriaProducto = () => {
  const [categorias, setCategorias] = useState({
    data: { categorias: [] },
    loading: true,
    error: "",
  });

  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaTodo();
  }, []);

  const consultaTodo = async () => {
    try {
      const datosCategorias = await getCategoriasProductos({ limit: 200 });

      setCategorias({
        data: {
          categorias: normalizarCategorias(datosCategorias),
        },
        loading: false,
        error: "",
      });
    } catch (e) {
      console.error("❌ Error al cargar categorías:", e);

      setCategorias({
        data: { categorias: [] },
        loading: false,
        error: e?.message || "Error al cargar categorías",
      });
    }
  };

  const handleClose = () => {
    setShow(false);
    setCategoriaSeleccionada(null);
    consultaTodo();
  };

  const handleShow = () => setShow(true);

  const modificaCategoria = (categoria) => {
    setCategoriaSeleccionada(categoria);
    handleShow();
  };

  const eliminarCategoria = async (id) => {
    if (!id) return;

    if (window.confirm("¿Está seguro que desea borrar la categoría?")) {
      try {
        await deleteCategoriaProducto(id);
        consultaTodo();
      } catch (error) {
        console.error("❌ Error al borrar categoría:", error?.response?.data || error);
        alert("No se pudo borrar la categoría. Revisá consola / Network.");
      }
    }
  };

  const rows = useMemo(() => {
    const arr = Array.isArray(categorias.data?.categorias)
      ? categorias.data.categorias
      : [];

    return arr
      .filter((c) => c?.activo ?? true)
      .map((c) => ({
        ...c,
        codigo: clean(c?.codigo).toUpperCase(),
        nombre: clean(c?.nombre).toUpperCase(),
        descripcion: clean(c?.descripcion).toUpperCase(),
        grupoRecepcion: clean(c?.grupoRecepcion || "OTRO").toUpperCase(),
        limitePorReceptorPorVenta: Number(c?.limitePorReceptorPorVenta || 0),
        usaColorDefault: Boolean(c?.usaColorDefault),
      }))
      .sort((a, b) => {
        const A = a?.nombre?.toString().trim() || "";
        const B = b?.nombre?.toString().trim() || "";

        if (!A && !B) return 0;
        if (!A) return 1;
        if (!B) return -1;

        return A.localeCompare(B, "es", { sensitivity: "base" });
      });
  }, [categorias]);

  if (categorias.loading) {
    return <div className="p-3">Cargando categorías…</div>;
  }

  if (categorias.error) {
    return <div className="p-3 text-danger">{categorias.error}</div>;
  }

  return (
    <div className="table-container">
      <div className="col-12 mt-4"></div>

      <Table striped bordered hover>
        <thead>
          <tr className="header">
            <th className="borrar">Acciones</th>
            <th>Código</th>
            <th>Categoría</th>
            <th>Grupo recepción</th>
            <th>Límite receptor</th>
            <th>Usa color</th>
            <th>Descripción</th>
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={7} className="text-center">
                No hay categorías cargadas.
              </td>
            </tr>
          ) : (
            rows.map((categoria) => (
              <tr key={categoria._id}>
                <td className="borrar" style={{ whiteSpace: "nowrap" }}>
                  <div className="d-flex align-items-center justify-content-center gap-2 flex-nowrap">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => modificaCategoria(categoria)}
                      title="Modificar categoría"
                    >
                      <i className="fa fa-pencil-square-o" />
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => eliminarCategoria(categoria._id)}
                      title="Borrar categoría"
                    >
                      <i className="fa fa-trash-o" />
                    </button>
                  </div>
                </td>

                <td>{categoria.codigo || "-"}</td>
                <td>{categoria.nombre || "-"}</td>
                <td>{categoria.grupoRecepcion || "-"}</td>
                <td>{categoria.limitePorReceptorPorVenta}</td>
                <td>{mostrarSiNo(categoria.usaColorDefault)}</td>
                <td>{categoria.descripcion || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <ModalCategoriaProducto
        show={show}
        handleClose={handleClose}
        categoria={categoriaSeleccionada}
      />
    </div>
  );
};

export default TableCategoriaProducto;